export default __webpack_public_path__ + "static/saas-platform-compliance-3e02b8b02cc708a76c79242c18971619.jpg";